import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { AbstractControlOptions, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-service-manual',
  templateUrl: './add-service-manual.component.html',
  styleUrls: ['./add-service-manual.component.scss']
})
export class AddServiceManualComponent implements OnInit {

  productServiceManualId: string | any;
  products: any = []
  imgFile: string | any;
  private sub: any;
  uploadForm = new FormGroup({
    productId: new FormControl(''),
    serviceManualTitle: new FormControl('', [Validators.required]),
    serviceManualDesc: new FormControl('',),
    type: new FormControl(''),
    file: new FormControl(''),
    imgSrc: new FormControl(''),
    ImageUrl: new FormControl(''),
  });

  isAddMode!: boolean;
  submitted = false;

  constructor(private http: HttpClient, public appService: AppService,
    private route: ActivatedRoute, private router: Router,
    public snackBar: MatSnackBar) { }


  ngOnInit(): void {

    this.getAllProducts();

    this.sub = this.route.params.subscribe(params => {
      if (params['id']) {
        this.productServiceManualId = params['id'];
        this.getServiceCatalogueById(this.productServiceManualId);
      }
    });

    this.productServiceManualId = this.route.snapshot.params['id'];
    this.isAddMode = !this.productServiceManualId;
    const passwordValidators = [Validators.minLength(6)];
    if (this.isAddMode) {
      passwordValidators.push(Validators.required);
    }


  }

  public getAllProducts = () => {

    this.appService.getProducts("/api/Product/").subscribe(data => {

      this.products = data;
    },
      error => {
        console.log(error.error.errors);
      })
  }
  public getServiceCatalogueById = (id) => {

    this.appService.getServiceCatalogueById("api/ProductServiceManual/" + id).subscribe((data: any) => {

      this.uploadForm.patchValue(data);

    })
    error => {
      console.log(error.error.errors);
    }
  }

  onSubmit() {

    if (this.isAddMode) {
      this.createUser();
    } else {
      this.updateUser();
    }
  }

  private createUser() {


    var formData = new FormData();
    formData.append('file', this.imgFile);
    formData.append('serviceManualTitle', this.uploadForm.value.serviceManualTitle);
    formData.append('serviceManualDesc', this.uploadForm.value.serviceManualDesc);
    formData.append('type', this.uploadForm.value.type);
    formData.append('productId', this.uploadForm.value.productId);   
    this.appService.addServiceCatalogue('api/ProductServiceManual/AddServiceManual', formData).subscribe((response: any) => {
      this.snackBar.open('Saved successfuly!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
      this.router.navigate(['/admin/serviceManual/ListServiceManual'], { relativeTo: this.route });
    }, error => {
      debugger;
      console.log(error);
      this.snackBar.open('Something went wrong!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    });
  }

  private updateUser() {

    var formData = new FormData();
    formData.append('productServiceManualId', this.productServiceManualId);
    formData.append('file', this.imgFile);
    formData.append('serviceManualTitle', this.uploadForm.value.serviceManualTitle);
    formData.append('serviceManualDesc', this.uploadForm.value.serviceManualDesc);
    formData.append('type', this.uploadForm.value.type);
    formData.append('productId', this.uploadForm.value.productId);
    console.log(this.uploadForm);
    this.appService.editServiceCatalogue('api/ProductServiceManual', formData).subscribe((response: any) => {
      this.snackBar.open('Update successfuly!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
      this.router.navigate(['/admin/serviceManual/ListServiceManual'], { relativeTo: this.route });
    }, error => {
      this.snackBar.open('Something went wrong!', '×', { panelClass: 'erroe', verticalPosition: 'top', duration: 3000 });
    }
    );

  }

  onImageChange(e: any) {
    this.imgFile = e.target.files[0];
    const reader = new FileReader();
    if (e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);
    }
  }

}